// extracted by mini-css-extract-plugin
export default {"syncButtonText":"syncButtonText__MjkECWOk","syncButtonLoading":"syncButtonLoading__R4C5U_tc"};